export default {
	init() {

		function SectionAboutLoadMovie( container ) {

			var youtubeID;
			var iframe;
			var thumbnail;

			container.querySelector('.videoWrapper__thumbnail').addEventListener('click', function() {

				thumbnail = container.querySelector('.videoWrapper__thumbnail');

				if( !thumbnail.classList.contains('disable') ) {

					youtubeID = container.getAttribute('data-id');

					iframe = document.createElement( "iframe" );

					iframe.setAttribute( "frameborder", "0" );
	        	    iframe.setAttribute( "allowfullscreen", "" );
	        	    iframe.setAttribute( "allow","accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" );
					iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ youtubeID +"?autoplay=1&rel=0&showinfo=0" );
	 				
					container.appendChild( iframe );

					thumbnail.classList.add('disable');
					iframe.classList.add('active');

					setTimeout(
						function(){

							container.removeChild(thumbnail);

						}, 400
					);

				}

			});

		}

		var container = document.querySelectorAll('.aboutSection .videoWrapper');

		if( container.length > 0 ) {

			container.forEach( function( box, index ) {

				SectionAboutLoadMovie( box );

			});

		}	
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
